module.exports = __webpack_public_path__ + "assets/pdf/I05-en-assessing-risk.73c3304c.pdf";